import {
  ProductTypeName,
  ProductStatusEnum,
} from '@electricjs/core_entity-client';

import { ProductTypeOption, ProductStatusOption } from '@/types/products';
import {
  productStatusDisplayIntent,
  productStatusDisplayName,
} from './formatters';
import getProductTypeLabel from '@/components/Assets/helpers/getProductTypeLabel';

/** Get all product type options (not just the "hardware" ones) */
export const transformProductTypesToOptions = (): ProductTypeOption[] => {
  return Object.values(ProductTypeName).map((productType: ProductTypeName) => ({
    value: productType,
    label: getProductTypeLabel(productType),
  }));
};

export const transformProductStatusToOptions = (): ProductStatusOption[] => {
  return Object.values(ProductStatusEnum).map(status => ({
    value: status,
    label: productStatusDisplayName[status],
    intent: productStatusDisplayIntent[status],
  }));
};
